import * as React from 'react';
import { Actions } from '../LoginPage';
import Axios from 'axios';
import '../../genericComponents/Button/LoaderButton.css';

interface State {
    /*Mail: string;
    CheckMail: boolean;
    NoMail: boolean;
    UnvalidMail: boolean;*/
    username: string;
    loading: boolean;
}

interface Props {
    actionHandler: (action: Actions) => void;
}

/**
 * Ce composant permet la reinitialisation d'un mot de passe
 */
export class ResPasswordForm extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
        this.state = {
            /*Mail: '',
            CheckMail: false,
            NoMail: false,
            UnvalidMail: false,*/
            username: '',
            loading: false,
        };
    }

    /*validateEmail = (email: string) => {
        var re = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
        return re.test(String(email).toLowerCase());
    }

    handleBadMail = () => {
        if (this.state.CheckMail) {
            if (this.state.Mail === '') {
                return <label className="text-danger"> Veuillez écrire votre adresse mail !</label>;
            } else if (!this.handlevalidateEmail()) {
                return <label className="text-danger">Adresse mail non valide !</label>;
            }
        }
        return '';
    }

    handleMailError = () => {
        if (this.state.Mail === '') {
            return false;
        } else if (!this.handlevalidateEmail()) {
            return false;
        }
        return true;
    }

    handleConfirmation = () => {
        if (!this.handleMailError()) {
            this.setState({ CheckMail: true });
        } else {
            alert('Le mot de passe à été envoyé à l\'adresse mail ' + this.state.Mail);
        }
    }*/

    handleConfirmation = () => {
        this.setState({loading: true});
        Axios.post(
            process.env.REACT_APP_RESET_PASSWORD_URL!,
            {
                username: this.state.username,
            }
        ).then(
            () => {
                this.setState({loading: false});
                this.props.actionHandler(Actions.LOGIN);
            }
        ).catch(
            () => {
                this.setState({loading: false});
                this.props.actionHandler(Actions.LOGIN);
            }
        );
    }

    render() {
        var button: JSX.Element;
        if (this.state.loading) {
            button = (
                <button
                    className="btn btn-lg col-12"
                    onClick={this.handleConfirmation}
                >
                    <i className="fas fa-spinner fa-spin" />
                </button>
            );
        } else {
            button = (
                <button
                    className="btn btn-lg col-12"
                    onClick={this.handleConfirmation}
                >
                    Valider
                </button>
            );
        }
        return (
            <div className="col-12">
                <p className="font-weight-bold">
                    Veuillez saisir votre nom d'utilisateur,
                    un mail sera envoyé sur l'adresse associée
                    à votre compte
                </p>
                <div className="form-group">
                    <input
                        className="form-control"
                        placeholder="Nom s'utilisateur"
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                this.setState(
                                    {
                                        username: e.target.value,
                                        usernameNotFound: false,
                                    }
                                );
                            }
                        }
                        value={this.state.username}
                        name="username"
                        type="text"
                    />
                </div>
                <hr />
                {button}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/LoginPage/internalComponents/ResPasswordForm.tsx